import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { VivaChatComponent } from './viva-chat.component';

@NgModule({
  declarations: [
    VivaChatComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective
  ],
  exports: [
    VivaChatComponent
  ]
})
export class  VivaChatModule { }
